import axios from "axios";
import { getAccessToken } from "../utils/token-cookie";
import { env } from "../config/env";

export const apiClient = axios.create({
  baseURL: env.API_BASE_URL,
  withCredentials: true,
});

// Intercepteur pour le Content-Type
apiClient.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    return config;
  }
  if (config.headers) {
    config.headers.set("Content-Type", "application/json");
  }
  return config;
});

// Intercepteur pour le token d'authentification
apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur de réponse pour gérer les erreurs
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    console.error("API Error:", status);

    if (status === 401) {
      // Inclure le chemin, la query string ET le hash
      const currentUrl = encodeURIComponent(
        window.location.pathname + window.location.search + window.location.hash
      );
      // On n'utilise plus localStorage ici car on se base sur le hash
      window.location.href = `/auth/login?redirect=${currentUrl}`;
    }

    if (status === 403) {
      console.warn("Accès interdit.");
    }
    return Promise.reject(error);
  }
);